import { defineComponent } from "vue";

export default defineComponent({
    inject: ["dialogRef"],

    data() {
        return {
            dialogReference: this.dialogRef as any,
            optionalMessage: "" as string,
            isRecurringEvent: false as boolean,
            isCancelSeries: false as boolean
        };
    },

    mounted() {
        this.isRecurringEvent = this.dialogReference?.data?.isRecurringEvent || false;
        this.isCancelSeries = this.dialogReference?.data?.isCancelSeries || false;
    },

    methods: {
        cancel() {
            this.dialogReference.close({ status: "cancel" });
        },

        submit() {
            this.dialogReference.close({
                status: "success",
                reason: this.optionalMessage,
                cancelRecurrence: this.isCancelSeries
            });
        }
    }
});
